import { RootState } from "redux/schemas";

export const getCommentTranslationById = (id: number) => (state: RootState) => state.app.discussionTranslation.comments[id];

export const getReplyTranslationById = (id: number) => (state: RootState) => state.app.discussionTranslation.replies[id];
